import * as Yup from "yup"

export const commonFormUIYupSchema = (props) =>
  Yup.object().shape({
    ...props,
  })
